import { useFetch } from "../../../hooks/api";
import { useMemo } from "react";
import { useAppSelector } from "../../../redux/hooks";
import useDSPSellerInfo from "./useDSPSellerInfo";

export const useDSPInventoryTargets = (
  inventoryType = "STANDARD_DISPLAY",
  inventorySource = "AMAZON",
  deviceType = ["DESKTOP"],
) => {
  const { marketPlace } = useAppSelector((state) => state.marketPlace);
  const { dspAdvertiser } = useDSPSellerInfo();

  const deviceTypeFilter = useMemo(() => {
    let formattedDeviceFilter = "";

    deviceType.forEach((deviceType) => {
      formattedDeviceFilter += `,DEVICE_TYPE:${deviceType}`;
    });

    return formattedDeviceFilter;
  }, [deviceType]);

  const { data, isLoading } = useFetch(
    ["dspInventoryTargets", inventoryType, inventorySource, dspAdvertiser?.id],
    "/dsp/inventory_source_exchanges",
    {
      filters: `INVENTORY_SOURCE_TYPE:${inventorySource},INVENTORY_TYPE:${inventoryType}${deviceTypeFilter}`,
      marketplace: marketPlace,
      dsp_seller_info_id: dspAdvertiser?.id,
    },
    {
      select: (res) => {
        return (
          res.data?.exchanges
            ?.reduce((acc, item) => {
              if (!acc.some((entry) => entry.id === item.id)) {
                acc.push(item);
              }
              return acc;
            }, [])
            ?.map((inventory) => {
              return { label: inventory.name, value: inventory.id };
            }) ?? []
        );
      },
      default: [],
      // Below is intentional to avoid overwriting user selected values, this should only be refetched when device types change
      staleTime: Infinity,
      gcTime: Infinity,
    },
  );

  return { data, isLoading };
};
